<div
  role="alert"
  class="flex items-center gap-3 rounded-xl border border-border-medium bg-white px-3.5 py-3 shadow-lg animate-slide-in-bottom"
>
  @switch (kind()) {
    @case ("success") {
      <div
        class="flex size-8 shrink-0 items-center justify-center rounded-full bg-success-tone-tint text-success-tone"
      >
        <span class="material-symbols-outlined text-[18px]">check_circle</span>
      </div>
    }
    @case ("error") {
      <div
        class="flex size-8 shrink-0 items-center justify-center rounded-full bg-danger-tone-tint text-danger-tone"
      >
        <span class="material-symbols-outlined text-[18px]">error</span>
      </div>
    }
    @default {
      <div
        class="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary"
      >
        <span class="material-symbols-outlined text-[18px]">info</span>
      </div>
    }
  }

  <!--
    The message carries the tone in its wording, not in its colour. Tinting the
    text as well as the icon is what made an error toast unreadable in dark
    mode, where a red on #1f1813 has nowhere near the contrast a red on white
    has — the chip is small enough to carry a low-contrast hue, a paragraph is
    not.
  -->
  <p class="flex-1 text-[13px] font-medium leading-snug text-text-primary">
    {{ message() }}
  </p>

  <button
    type="button"
    (click)="dismiss.emit()"
    aria-label="Dismiss"
    class="flex size-10 shrink-0 items-center justify-center rounded-lg text-text-tertiary transition-colors hover:bg-inset hover:text-text-primary"
  >
    <span class="material-symbols-outlined text-[18px]">close</span>
  </button>
</div>
